import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { SfChevronDownIcon } from '@ninja/icons/web';
import { formatDate } from '@ninja/utilities';
import styles from './DatePicker4.js';
import { useCalendarViewContext } from './components10.js';

const TimeViewHeader = () => {
    const { updateViewState, viewState: { tzDate, currentCalendar }, } = useCalendarViewContext();
    return (jsx(Fragment, { children: jsxs("div", { className: "flex w-full justify-between text-[color:var(--nj-brand)] items-center", onClick: () => {
                updateViewState({ viewMode: 'days' });
            }, children: [formatDate(tzDate, { calendar: currentCalendar }), jsx(SfChevronDownIcon, { className: styles.navigationIcon(false) })] }) }));
};

export { TimeViewHeader };
